/**
 * يوحّد عرض «عدد الطلبات» بين قائمة المطاعم/الماركت، التفاصيل، والمفضلة
 * لأن الباك قد يرسل حقولاً مختلفة حسب الـ endpoint.
 */
export function resolveStoreOrdersCount(store) {
  if (!store || typeof store !== "object") return 0;

  const candidates = [
    store._orders_count_normalized,
    store.delivered_orders_count,
    store.orders_count,
    store.total_orders,
    store.completed_orders_count,
    store.orders_total,
    store.stats?.delivered_orders_count,
    store.stats?.orders_count,
    store.stats?.total_orders,
    store.statistics?.delivered_orders_count,
    store.statistics?.orders_count,
    store.statistics?.total_orders,
  ];

  const nums = candidates
    .map((v) => Number(v))
    .filter((n) => !Number.isNaN(n) && n >= 0);

  if (!nums.length) return 0;
  return Math.max(...nums);
}

/** نفس أولوية `RestaurantHomeCard` (أول قيمة معرّفة). */
export function resolveHomeCardOrdersCount(store) {
  if (!store || typeof store !== "object") return null;
  const n =
    store.delivered_orders_count ??
    store.orders_count ??
    store.total_orders ??
    store.completed_orders_count ??
    store.orders_total;
  if (n == null || n === "") return null;
  const num = Number(n);
  return Number.isNaN(num) ? null : num;
}

/** نفس منطق `MarketHomeCard.ordersCount` (أعلى قيمة صالحة بين المرشّحات). */
export function resolveMarketHomeCardOrdersCount(market) {
  if (!market || typeof market !== "object") return null;
  const candidates = [
    market._orders_count_normalized,
    market.delivered_orders_count,
    market.orders_count,
    market.total_orders,
    market.completed_orders_count,
    market.orders_total,
    market.stats?.delivered_orders_count,
    market.stats?.orders_count,
  ];
  const parsed = candidates
    .map((v) => Number(v))
    .filter((n) => !Number.isNaN(n) && n >= 0);
  if (parsed.length === 0) return null;
  return Math.max(...parsed);
}

/** للمفضلة: نفس كارت الرئيسية حسب نوع المتجر. */
export function resolveFavoriteOrdersCount(store, storeType) {
  if (!store || typeof store !== "object") return 0;
  if (storeType === "market") {
    const v = resolveMarketHomeCardOrdersCount(store);
    return v != null ? v : resolveStoreOrdersCount(store);
  }
  const v = resolveHomeCardOrdersCount(store);
  return v != null ? v : resolveStoreOrdersCount(store);
}
